import { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useRouteError } from 'react-router';
import { Alert, Button, PageLoader } from '@shripos/ui';
import { api } from '../lib/api.js';
import { useSession } from '../stores/session.js';

/** Resolves "who am I" once on load (refreshing the session cookie if needed). */
export function AppBoot() {
  const status = useSession((s) => s.status);
  useEffect(() => {
    if (status !== 'loading') return;
    api
      .get('/auth/me')
      .then((r) => useSession.getState().signedIn(r.admin))
      .catch(() => useSession.getState().signedOut());
  }, [status]);
  if (status === 'loading') return <PageLoader label="Starting ShriPOS Admin…" />;
  return <Outlet />;
}

export function RequireAuth({ children }) {
  const status = useSession((s) => s.status);
  const location = useLocation();
  if (status !== 'authenticated') return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export function PublicOnly() {
  const status = useSession((s) => s.status);
  if (status === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RouteError() {
  const error = useRouteError();
  return (
    <div className="mx-auto max-w-lg p-8">
      <Alert tone="danger" title="Something went wrong">
        {error?.message ?? 'Unexpected error'}
      </Alert>
      <Button className="mt-4" variant="secondary" onClick={() => window.location.assign('/')}>
        Back to dashboard
      </Button>
    </div>
  );
}
